module.exports = __webpack_public_path__ + "static/media/partner-logo2.69fe175e.png";